export type DomainNumbering = ReadonlyArray<string | null>;

/**
 * The antibody numbering shown for a residue. A domain with no numbering at all has its
 * residues identified by their 1-based position in the domain's sequence instead. An index outside
 * the sequence is shown by its 1-based position alone, e.g. "idx:5".
 *
 * @param residues The sequence of the domain the residue is in.
 * @param numbering The numbering of the domain the residue is in, or null if it has none. Must be
 *   index-aligned with `residues`: `numbering[i]` is the number of `residues[i]`.
 * @param residueIndex The zero-based index of the residue within the domain.
 */
export function getAntibodyNumbering(
  residues: string,
  numbering: DomainNumbering | null,
  residueIndex: number
): string {
  const residue = residues[residueIndex];
  if (residue == null) {
    return `idx:${residueIndex + 1}`;
  }
  if (numbering == null || numbering[residueIndex] == null) {
    return `${residue}-idx:${residueIndex + 1}`;
  }
  return `${residue}${numbering[residueIndex]}`;
}
